export default __webpack_public_path__ + "static/media/dancers.c44df636.svg";